{
  "page": {
    "title": "Contacto",
    "subtitle": "Estamos aqui para ajudar. Envie-nos a sua mensagem.",
    "branchLabel": "Unidade"
  },
  "form": {
    "submit": "Enviar mensagem",
    "thanks": "Obrigado! Recebemos a sua mensagem e entraremos em contacto em breve.",
    "consent": "Ao enviar, concorda com o tratamento dos seus dados de acordo com a nossa política de privacidade.",
    "marketingOptIn": "Quero receber dicas úteis e ofertas da clínica por email.",
    "name": "Nome",
    "namePlaceholder": "O seu nome",
    "email": "E-mail",
    "emailPlaceholder": "exemplo@email.com",
    "phone": "Telefone",
    "phonePlaceholder": "+351 ___ ___ ___",
    "clinic": "Clínica preferida",
    "clinicPlaceholder": "Selecione uma clínica",
    "subject": "Assunto",
    "subjectPlaceholder": "O motivo da sua consulta (opcional)",
    "message": "Mensagem",
    "messagePlaceholder": "Escreva a sua mensagem",
    "sending": "A enviar…",
    "successTitle": "Mensagem enviada",
    "successBody": "Obrigado. A resposta segue para o e-mail que indicou.",
    "errorTitle": "Não foi possível enviar",
    "emailOptional": "E-mail (opcional)",
    "leadSubmit": "Quero ser contactado",
    "leadSuccessTitle": "Pedido recebido",
    "leadSuccessBody": "Obrigado. A clínica entra em contacto consigo em breve pelo número que indicou."
  },
  "errors": {
    "rateLimited": "Demasiados pedidos. Por favor, tente novamente dentro de alguns minutos.",
    "generic": "Ocorreu um erro ao enviar a mensagem. Tente novamente.",
    "captchaPending": "Conclua a verificação de segurança antes de enviar.",
    "captchaFailed": "A verificação de segurança falhou. Tente novamente."
  },
  "validation": {
    "nameRequired": "Indique o seu nome.",
    "emailInvalid": "Indique um e-mail válido.",
    "clinicRequired": "Escolha uma clínica.",
    "messageRequired": "Escreva uma mensagem.",
    "consentRequired": "É necessário aceitar a política.",
    "phoneRequired": "Indique um número de telemóvel válido.",
    "emailForMarketing": "Para receber as novidades, indique o seu e-mail."
  },
  "unavailable": {
    "title": "Formulário temporariamente indisponível",
    "body": "Não foi possível carregar o formulário. Tente novamente dentro de momentos."
  }
}
